const get_all_store_data = 'https://pep.commercebridge.tech/rest/v1/collection/stores'
//const get_all_store_data_long_lat = 'https://pep.commercebridge.tech/rest/v1/routing/delivery-stores'
const get_all_store_data_long_lat = 'https://pep.commercebridge.tech/rest/v1/routing/all-in-one'

const get_store_locator_data = 'https://pep.commercebridge.tech/rest/v1/store/locator'
const provinceDataUrl = "https://pep.commercebridge.tech/rest/v1/collection/stores/province"  // provinceDataUrl API
const suburbDataUrl = "https://pep.commercebridge.tech/rest/v1/collection/stores/suburb" //suburbData API
const storestock_Url = "https://pep.commercebridge.tech/rest/v1/collection/stores/open"//store_stock_Data API
const selected_store_data_Url= "https://pep.commercebridge.tech/rest/v1/stock/fetch"//selected_store_Data API
const middleware_api_key = '0P7JP8EXRA1FHGAA8SV52J146LG3QH30TTVPR56W'
const peach_entity_id = '8ac7a4c871819ce9017182a62b9a06da'
const peach_secret = '67c1707f7fd111ea93d502d14de18c0c'
const peach_checkout_url = 'https://testsecure.peachpayments.com/checkout'
